import React, { FC } from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'

import { Typography } from 'components/designSystem/Typography/Typography'
import { GQLPhotoItemFragment } from 'components/page/ForeignProfile/gql/__generated__/Photos'
import { GQLPhotoFaceCenter } from 'generated-graphql/graphql'

import { Photo } from './Photo'

export const PhotoMore: FC<{ photos: GQLPhotoItemFragment[] }> = ({
  photos,
}) => {
  const photo = photos[0]

  if (photo) {
    return (
      <Photo
        photoId={photo.photoId}
        xHuge={photo.urls.xHuge}
        huge={photo.urls.huge}
        width={photo.width}
        height={photo.height}
        mask={<Mask count={photos.length} />}
        coordinates={photo.faceCenter as GQLPhotoFaceCenter}
      />
    )
  }

  return null
}

const Mask: FC<{ count: number }> = ({ count }) => {
  return (
    <Parent>
      <Fill />
      <Text
        fontSize={32}
        fontWeight={500}
        tag="p"
        style={{
          color: 'var(--static-white)',
        }}
      >
        <FormattedMessage
          defaultMessage="еще {breakLine} {count} фото"
          id="app.foreign.profile.more.photos"
          values={{
            count,
            breakLine: <br />,
          }}
        />
      </Text>
    </Parent>
  )
}

const Parent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  min-width: 100%;
  min-height: 100%;
  color: var(--static-white);
  text-align: center;
`

const Text = styled(Typography)`
  position: relative;
`

const Fill = styled.div`
  position: absolute;
  inset: 0;
  min-width: 100%;
  min-height: 100%;
  background-color: var(--purpur-hard);
  opacity: 0.8;
`
